import { render, staticRenderFns } from "./SpiderDetail.vue?vue&type=template&id=423f1876&scoped=true&"
import script from "./SpiderDetail.vue?vue&type=script&lang=js&"
export * from "./SpiderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpiderDetail.vue?vue&type=style&index=0&id=423f1876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f1876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423f1876')) {
      api.createRecord('423f1876', component.options)
    } else {
      api.reload('423f1876', component.options)
    }
    module.hot.accept("./SpiderDetail.vue?vue&type=template&id=423f1876&scoped=true&", function () {
      api.rerender('423f1876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/spider/SpiderDetail.vue"
export default component.exports